import routes from 'app/two-factor/routes';

export default {
  routes,
};
